import { render, staticRenderFns } from "./Top10Titles.vue?vue&type=template&id=d526dc22&scoped=true"
import script from "./Top10Titles.vue?vue&type=script&lang=ts&setup=true"
export * from "./Top10Titles.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Top10Titles.vue?vue&type=style&index=0&id=d526dc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d526dc22",
  null
  
)

export default component.exports